import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, Dialog, EmptyState, Loading, StatusBadge } from "../../components/VB";
import { toast } from "sonner";
import { Check, X } from "lucide-react";

export default function IzinAdmin() {
  const [items, setItems] = useState([]);
  const [emps, setEmps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [decideTarget, setDecideTarget] = useState(null);
  const [decideStatus, setDecideStatus] = useState("Approved");
  const [catatan, setCatatan] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [filterEmp, setFilterEmp] = useState("");
  const [filterBulan, setFilterBulan] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const params = {};
      if (filterStatus) params.status = filterStatus;
      if (filterEmp) params.employee_id = filterEmp;
      if (filterBulan) params.bulan = filterBulan;
      const [i, e] = await Promise.all([api.get("/izin", { params }), api.get("/employees")]);
      setItems(i.data); setEmps(e.data);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filterStatus, filterEmp, filterBulan]);

  const empName = (id) => emps.find((e) => e.id === id)?.nama_lengkap || "-";

  const decide = async () => {
    try {
      await api.post(`/izin/${decideTarget.id}/decision`, { status: decideStatus, catatan_admin: catatan });
      toast.success(`Izin ${decideStatus === "Approved" ? "disetujui" : "ditolak"}`);
      setDecideTarget(null); setCatatan(""); load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  return (
    <Window title="Management Izin Karyawan">
      <div style={{ display: "flex", gap: 6, marginBottom: 10, flexWrap: "wrap" }}>
        <select className="vb-select" style={{ width: 160 }} value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)} data-testid="izin-filter-status">
          <option value="">Semua Status</option>
          <option>Pending</option><option>Approved</option><option>Rejected</option>
        </select>
        <select className="vb-select" style={{ width: 200 }} value={filterEmp} onChange={(e) => setFilterEmp(e.target.value)} data-testid="izin-filter-emp">
          <option value="">Semua Karyawan</option>
          {emps.map((e) => <option key={e.id} value={e.id}>{e.nama_lengkap}</option>)}
        </select>
        <input type="month" className="vb-input" style={{ width: 160 }} value={filterBulan} onChange={(e) => setFilterBulan(e.target.value)} data-testid="izin-filter-bulan" />
      </div>

      {loading ? <Loading /> : items.length === 0 ? <EmptyState /> : (
        <div style={{ overflowX: "auto" }}>
          <table className="vb-table">
            <thead><tr><th>Tanggal</th><th>Karyawan</th><th>Jenis</th><th>Keterangan</th><th>Status</th><th>Catatan Admin</th><th>Aksi</th></tr></thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.id}>
                  <td>{it.tanggal}</td>
                  <td>{empName(it.employee_id)}</td>
                  <td>{it.jenis}</td>
                  <td>{it.keterangan}</td>
                  <td><StatusBadge status={it.status} /></td>
                  <td>{it.catatan_admin || "-"}</td>
                  <td>
                    {it.status === "Pending" && (
                      <>
                        <button className="vb-btn" style={{ padding: "2px 6px", marginRight: 4 }} onClick={() => { setDecideTarget(it); setDecideStatus("Approved"); }} data-testid={`approve-${it.id}`}>
                          <Check className="w-3 h-3 inline" /> Approve
                        </button>
                        <button className="vb-btn-danger" style={{ padding: "2px 6px" }} onClick={() => { setDecideTarget(it); setDecideStatus("Rejected"); }} data-testid={`reject-${it.id}`}>
                          <X className="w-3 h-3 inline" /> Reject
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <Dialog open={!!decideTarget} onClose={() => setDecideTarget(null)} title={`${decideStatus === "Approved" ? "Setujui" : "Tolak"} Izin`}
        footer={<><button className="vb-btn" onClick={() => setDecideTarget(null)}>Batal</button>
          <button className={decideStatus === "Approved" ? "vb-btn-primary" : "vb-btn-danger"} onClick={decide} data-testid="confirm-decision">Konfirmasi</button></>}>
        <p style={{ fontSize: 13 }}>Izin <b>{empName(decideTarget?.employee_id)}</b> pada <b>{decideTarget?.tanggal}</b></p>
        <div className="vb-form-row"><label className="vb-label">Catatan Admin (opsional)</label>
          <textarea className="vb-textarea" rows={3} value={catatan} onChange={(e) => setCatatan(e.target.value)} data-testid="decision-catatan" /></div>
      </Dialog>
    </Window>
  );
}
